import FadeOutEffect from "components/atoms/FadeOutEffect"
import Faq from "./faq.mdx"
import Faq_ar from "./faq_ar.mdx"
import { useLang } from "hooks/useLang"

const FaqComponent = () => {
    const { lang } = useLang()
    const renderFaq = lang === "ar" ? <Faq_ar /> : <Faq />
    const externalUrl =
        lang === "ar"
            ? "https://saudiarabiangp.com/ar/support-faq"
            : "https://saudiarabiangp.com/en/support-faq"
    return (
        <FadeOutEffect externalLink={externalUrl} fadeStartAt={180} fadeHeight={50}>
            <div className="max-w-2xl ">
                <div
                    style={{
                        fontWeight: 300,
                    }}
                >
                    {renderFaq}
                </div>
            </div>

        </FadeOutEffect>
    )
}

export default FaqComponent
